module.exports = __webpack_public_path__ + "static/media/Logo_Bravecto_fr.9f403c8b.svg";